import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen';

import React from 'react';

import { Button } from 'ui-components/components/button';
import { FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import styles from './edit-button.module.less';
import { messages } from './messages';

/**
 * @param {object} props
 * @param {() => void} props.onClick
 * @returns {JSX.Element}
 */
export const EditButton = ({ onClick }) => (
  <Button className={styles.button} onClick={onClick} theme='link'>
    <FlexRow className={styles.wrapper} gap={Gap.Space4}>
      <FontAwesomeIcon className={styles.icon} icon={faPen} />
      <Text textType={TextType.Paragraph} value={messages.editButton} />
    </FlexRow>
  </Button>
);
